import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mybeema_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_1b9f657d-10f9-4c00-9443-ef91a5856148/artifacts/wsu0nn3m_LOGO.jpeg";
